import axios from 'axios'

const usuarios = {}

usuarios.find = (id) => axios.get(`/usuarios/${id}`)
usuarios.alterPassword = (data) => axios.post('/usuarios/alterar_senha', data)
usuarios.findPerfis = () => axios.get('/usuarios/obterPerfis')
usuarios.recoverPassword = email => axios.get(`/usuarios/recuperar_senha/${email}`)
usuarios.updatePassword = data => axios.post('/usuarios/alterarSenha', data)
usuarios.webAulaVerificar = (cpf, email) => axios.get(`/usuarios/integracaoWebAula/verificar/${cpf}/${email}`)
usuarios.webAulaAtualizar = (id, usuario) => axios.put(`/usuarios/integracaoWebAula/atualizar/${id}`, usuario)
usuarios.webAulaCadastrar = usuario => axios.post('/usuarios/integracaoWebAula/cadastrar', usuario)
usuarios.objetosFavoritos = (id, skip, quantidade, tipoId) => axios.get(`/usuarios/${id}/objetos_favoritos?skip=${skip}&quantidade=${quantidade}&tipo=${tipoId}`)
usuarios.vincularFavoritos = (id, objeto) => axios.post(`/usuarios/${id}/objetos_favoritos/`, { objetoId: objeto })
usuarios.desvincularFavoritos = (id, objeto) => axios.delete(`/usuarios/${id}/objetos_favoritos/${objeto}`)

export { usuarios }
